import AccordionTextBlock from "@/components/AccordionTextBlock/AccordionTextBlock";
import { ContentBlock } from "@/components/ContentBlock/ContentBlock";
import type { FundDetailLayoutComponentProps } from "@/types/fundDetailLayout";

export const FxBenchmarkInformationPanel = ({ dashboard, flex }: FundDetailLayoutComponentProps) => {
	const { fxBenchmarkInformationPanel: props } = dashboard;
	if (!props) {
		return null;
	}

	return (
		<ContentBlock id="fxBenchmarkInformationPanel" data-testid="FxBenchmarkInformationPanel" flex={flex} tabIndex={-1}>
			<AccordionTextBlock {...props} />
		</ContentBlock>
	);
};
